import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/youtube-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M186.8 202.1l95.2 54.1-95.2 54.1v-108.2zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM406 256.3c0 0 0-59.6-7.6-88.2-4.2-15.8-16.5-28.2-32.2-32.4-28.3-7.7-142.2-7.7-142.2-7.7s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9 28.3 7.6 142.2 7.6 142.2 7.6s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/youtube-square.js
// module id = 1113
// module chunks = 0